import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src="https://public.readdy.ai/ai/img_res/a2112a7d-cd2d-4121-9398-95a07520b04f.png"
              alt="KLCarPool Logo"
              className="h-10 w-auto"
            />
            <div className="ml-3 flex flex-col">
              <span className={`text-lg font-bold tracking-tight ${isScrolled ? 'text-gray-900' : 'text-white'}`} style={{ fontFamily: "'Montserrat', sans-serif" }}>
                KLCarPool
              </span>
              <span className={`text-[10px] font-medium tracking-wide ${isScrolled ? 'text-gray-500' : 'text-white/80'}`} style={{ fontFamily: "'Inter', sans-serif" }}>
                by <strong className="font-bold">Drixem Group</strong>
              </span>
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('ai-features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('verified-community')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Community
            </button>
            <button
              onClick={() => scrollToSection('leadership')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Leadership
            </button>
            <button
              onClick={() => scrollToSection('launch-plan')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Roadmap
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('waitlist')}
            className={`hidden lg:block px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'bg-teal-600 text-white hover:bg-teal-700'
                : 'border-2 border-white text-white hover:bg-white hover:text-teal-600'
            }`}
          >
            Join Waitlist
          </button>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3 bg-white rounded-lg p-4 shadow-lg">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('ai-features')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Features
            </button>
            <button onClick={() => scrollToSection('verified-community')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Community
            </button>
            <button onClick={() => scrollToSection('leadership')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Leadership
            </button>
            <button onClick={() => scrollToSection('launch-plan')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Roadmap
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-sm font-medium text-gray-700 hover:text-teal-600 cursor-pointer">
              Contact
            </button>
            <button onClick={() => scrollToSection('waitlist')} className="w-full mt-4 px-6 py-2.5 bg-teal-600 text-white rounded-full text-sm font-medium hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer">
              Join Waitlist
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
